import React from "react";
import { ScreenShell, SelectableCard } from "../components";
import { T } from "../theme";
import type { Sex } from "../types";

type Props = {
  step: number;
  total: number;
  value: Sex | null;
  onChange: (v: Sex) => void;
  onNext: () => void;
  onBack: () => void;
  isMobile: boolean;
};

export function SexScreen({ step, total, value, onChange, onNext, onBack, isMobile }: Props): React.ReactElement {
  return (
    <ScreenShell
      step={step}
      total={total}
      title="Biological sex"
      subtitle={(
        <span>
          Used once for the BMR calculation. <span style={{ color: T.muted }}>Not stored anywhere else.</span>
        </span>
      )}
      onBack={onBack}
      isMobile={isMobile}
      primaryLabel="Continue"
      primaryDisabled={value === null}
      onPrimary={onNext}
    >
      <div style={{ display: "grid", gap: 12 }}>
        <SelectableCard selected={value === "M"} onClick={() => onChange("M")} title="Male" />
        <SelectableCard selected={value === "F"} onClick={() => onChange("F")} title="Female" />
        <SelectableCard
          selected={value === "X"}
          onClick={() => onChange("X")}
          title="Prefer not to say"
          body="We'll use an averaged formula. Slightly less precise, still useful."
        />
      </div>
    </ScreenShell>
  );
}
